import type { BackendChartData, BackendVaultDetailed } from '@/types'
import { formatUnits, safeNumber } from '../valueUtils'

export function composeTvlChartData(vaultData: BackendVaultDetailed, chartData: BackendChartData) {
  return chartData.map((dataPoint) => ({
    ...dataPoint,
    tvlNative: safeNumber(formatUnits(BigInt(dataPoint.tvlNative), vaultData.asset.decimals)) ?? 0,
  }))
}
